import Vue from 'vue'
import Vuex from 'vuex'
import currentPlan from './modules/currentPlan'
import custom from './modules/custom'
import selectOptions from './modules/selectOptions'
import systemConfig from './modules/systemConfig'
import permission from './modules/permission'
import app from './modules/app'
import getters from './getters'
Vue.use(Vuex)


export default new Vuex.Store({
  state: {
    level: [{ id: 1, name: '高起专' }, { id: 2, name: '专升本' }, { id: 3, name: '高起本' }],
    // 证件类型列表（初始为空数组，由接口获取后填充）
    cardTypeList: [],
    // 证件类型列表是否已加载
    isCardTypeListLoaded: false,
    userInfo: {},
    pageThis: null,
    // 未读消息数量
    sUnReadMsgCount: 0
  },
  mutations: {
    setUserInfo: (state, data) => {
      state.userInfo = data
    },
    SAVE_PAGE_THIS(state, _this) {
      state.pageThis = _this
    },
    updateUnReadMsgCount(state, count) {
      state.sUnReadMsgCount = count;
    },
    // 设置证件类型列表
    SET_CARD_TYPE_LIST(state, data) {
      state.cardTypeList = data;
      state.isCardTypeListLoaded = true;
    },
    // 重置证件类型列表
    RESET_CARD_TYPE_LIST(state) {
      state.cardTypeList = [];
      state.isCardTypeListLoaded = false;
    }
  },
  actions: {
    // 获取证件类型列表
    async fetchCardTypeList({ commit, state }) {
      // 如果已加载过，直接返回缓存数据
      if (state.isCardTypeListLoaded && state.cardTypeList.length > 0) {
        return state.cardTypeList;
      }
      try {
        const params = {
          tenant: window.localStorage.getItem("tenant")
        }
        const res = await Vue.prototype.$api.login.getCardTypeList(params);
        console.log(res);

        if (res.code) {
          commit('SET_CARD_TYPE_LIST', res.data);
          return res.data;
        }
        return [];
      } catch (error) {
        console.error('获取证件类型列表失败:', error);
        return [];
      }
    }
  },
  getters: {
    ...getters,
    // 根据 ID 获取证件类型名称
    getCardTypeName: (state) => (id) => {
      if (!id) return '';
      const item = state.cardTypeList.find(item => item.id === Number(id));
      return item ? item.name : '';
    },
    // 获取格式化的证件类型选项（用于 el-select）
    cardTypeOptions: (state) => {
      return state.cardTypeList.map(item => ({
        label: item.name,
        value: item.id
      }));
    }
  },
  modules: {
    custom,
    currentPlan,
    selectOptions,
    systemConfig,
    permission,
    app,
  }
})
